"use strict";

var _regeneratorRuntime = require("/node_modules/@babel/runtime/regenerator/index.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wallet = void 0;

require("isomorphic-unfetch");

var _browserOrNode = require("browser-or-node");

var _nearApiJs = require("near-api-js");

var _bn = _interopRequireDefault(require("bn.js"));

var _api = require("./api");

var _types = require("./types");

var _constants = require("./constants");

var _minter = require("./minter");

var _nearCosts = require("./utils/near-costs");

var _externalConstants = require("./utils/external-constants");

var _responseBuilder = require("./utils/responseBuilder");

var _message = require("./utils/message");

var _tweetnacl = require("tweetnacl");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 * Mintbase Wallet.
 * Main entry point for users to sign and interact with NEAR and Mintbase infrastructure.
 */


var Wallet = /*#__PURE__*/function () {
  /**
   * Mintbase wallet constructor.
   * Creates an instance of a Mintbase wallet.
   * @param apiConfig api confuguration options.
   * @returns the wallet instance
   */
  function Wallet() {
    var _this = this;

    _classCallCheck(this, Wallet);

    _defineProperty(this, "api", void 0);

    _defineProperty(this, "activeWallet", void 0);

    _defineProperty(this, "activeNearConnection", void 0);

    _defineProperty(this, "activeAccount", void 0);

    _defineProperty(this, "networkName", _types.Network.testnet);

    _defineProperty(this, "chain", _types.Chain.near);

    _defineProperty(this, "keyStore", void 0);

    _defineProperty(this, "nearConfig", void 0);

    _defineProperty(this, "minter", void 0);

    _defineProperty(this, "constants", void 0);

    _defineProperty(this, "rpcCall", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
        var _ref$headers, headers, _ref$body, body, method, request, data;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ref$headers = _ref.headers, headers = _ref$headers === void 0 ? {} : _ref$headers, _ref$body = _ref.body, body = _ref$body === void 0 ? {} : _ref$body, method = _ref.method;

                if (_this.nearConfig) {
                  _context.next = 3;
                  break;
                }

                throw new Error('NEAR Config not defined.');

              case 3:
                _context.next = 5;
                return fetch(_this.nearConfig.nodeUrl, {
                  method: 'POST',
                  body: JSON.stringify(_objectSpread(_objectSpread({}, body), {}, {
                    jsonrpc: '2.0',
                    id: "mintbase-".concat(Math.random().toString().substr(2, 10)),
                    method: method
                  })),
                  headers: _objectSpread(_objectSpread({}, headers), {}, {
                    'Content-Type': 'application/json'
                  })
                });

              case 5:
                request = _context.sent;
                _context.next = 8;
                return request.json();

              case 8:
                data = _context.sent;
                return _context.abrupt("return", data === null || data === void 0 ? void 0 : data.result);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(this, "viewAccessKey", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(accountId, publicKey) {
        var result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this.rpcCall({
                  body: {
                    params: {
                      request_type: 'view_access_key',
                      finality: 'final',
                      account_id: accountId,
                      public_key: publicKey
                    }
                  },
                  method: 'query'
                });

              case 2:
                result = _context2.sent;
                return _context2.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: result
                }));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2, _x3) {
        return _ref3.apply(this, arguments);
      };
    }());

    _defineProperty(this, "viewAccessKeyList", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(accountId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this.rpcCall({
                  body: {
                    params: {
                      request_type: 'view_access_key_list',
                      finality: 'final',
                      account_id: accountId
                    }
                  },
                  method: 'query'
                });

              case 2:
                result = _context3.sent;
                return _context3.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: result
                }));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x4) {
        return _ref4.apply(this, arguments);
      };
    }());

    _defineProperty(this, "transactionStatus", /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(transactionHash, accountId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this.rpcCall({
                  body: {
                    params: [transactionHash, accountId]
                  },
                  method: 'tx'
                });

              case 2:
                result = _context4.sent;
                return _context4.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: result
                }));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x5, _x6) {
        return _ref5.apply(this, arguments);
      };
    }());

    _defineProperty(this, "transactionStatusWithReceipts", /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(transactionHash, accountId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this.rpcCall({
                  body: {
                    params: [transactionHash, accountId]
                  },
                  method: 'EXPERIMENTAL_tx_status'
                });

              case 2:
                result = _context5.sent;
                return _context5.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: result
                }));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x7, _x8) {
        return _ref6.apply(this, arguments);
      };
    }());

    this.constants = {};
  }

  _createClass(Wallet, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(walletConfig) {
        var data;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return (0, _externalConstants.initializeExternalConstants)({
                  apiKey: walletConfig.apiKey,
                  networkName: walletConfig.networkName || this.networkName
                });

              case 3:
                this.constants = _context6.sent;
                this.api = new _api.API({
                  networkName: walletConfig.networkName || this.networkName,
                  chain: walletConfig.chain || this.chain,
                  constants: this.constants
                });
                this.networkName = walletConfig.networkName || _types.Network.testnet;
                this.chain = walletConfig.chain || _types.Chain.near;
                this.nearConfig = this.getNearConfig(this.networkName);
                this.keyStore = this.getKeyStore();
                this.minter = new _minter.Minter({
                  apiKey: walletConfig.apiKey,
                  constants: this.constants
                });
                _context6.next = 12;
                return this.connect();

              case 12:
                data = {
                  wallet: this,
                  isConnected: this.isConnected()
                }; // TODO: decide if we should really return the formatted response or the atual instance

                return _context6.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: data
                }));

              case 16:
                _context6.prev = 16;
                _context6.t0 = _context6["catch"](0);
                return _context6.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: _context6.t0
                }));

              case 19:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 16]]);
      }));

      function init(_x9) {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "isConnected",
    value: function isConnected() {
      var _this$activeWallet$is, _this$activeWallet;

      return (_this$activeWallet$is = (_this$activeWallet = this.activeWallet) === null || _this$activeWallet === void 0 ? void 0 : _this$activeWallet.isSignedIn()) !== null && _this$activeWallet$is !== void 0 ? _this$activeWallet$is : false;
    }
    /**
     * Creates a connection to a NEAR smart contract
     * @param props wallet connection properties - the config to create a connection with
     *
     */

  }, {
    key: "connect",
    value: function () {
      var _connect2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var props,
            contractAddress,
            _connectionObject,
            near,
            _accountId,
            privateKey,
            _connectionObject2,
            _near,
            _accountId2,
            _args7 = arguments;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                props = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
                contractAddress = props.contractAddress || this.constants.FACTORY_CONTRACT_NAME || _constants.FACTORY_CONTRACT_NAME;

                if (!_browserOrNode.isBrowser) {
                  _context7.next = 23;
                  break;
                }

                _connectionObject = _objectSpread({
                  deps: {
                    keyStore: this.getKeyStore()
                  }
                }, this.getNearConfig(this.networkName, contractAddress));
                _context7.next = 6;
                return (0, _nearApiJs.connect)(_connectionObject);

              case 6:
                near = _context7.sent;
                this.activeNearConnection = near;
                this.activeWallet = new _nearApiJs.WalletAccount(near, _constants.DEFAULT_APP_NAME);

                if (!(props !== null && props !== void 0 && props.requestSignIn)) {
                  _context7.next = 13;
                  break;
                }

                this.activeWallet.requestSignIn(contractAddress, _constants.DEFAULT_APP_NAME);
                _context7.next = 18;
                break;

              case 13:
                if (!this.activeWallet.isSignedIn()) {
                  _context7.next = 18;
                  break;
                }

                _accountId = this.activeWallet.getAccountId();
                _context7.next = 17;
                return this.activeNearConnection.account(_accountId);

              case 17:
                this.activeAccount = _context7.sent;

              case 18:
                _context7.next = 20;
                return (0, _nearApiJs.connect)(_connectionObject);

              case 20:
                return _context7.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: 'connected'
                }));

              case 23:
                if (!_browserOrNode.isNode) {
                  _context7.next = 39;
                  break;
                }

                privateKey = props.privateKey;

                if (privateKey) {
                  _context7.next = 27;
                  break;
                }

                return _context7.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'Private key is not defined.'
                }));

              case 27:
                this.setSessionKeyPair(this.constants.FACTORY_CONTRACT_NAME || _constants.FACTORY_CONTRACT_NAME, privateKey);
                _connectionObject2 = _objectSpread({
                  deps: {
                    keyStore: this.getKeyStore()
                  }
                }, this.getNearConfig(this.networkName, contractAddress));
                _near = new _nearApiJs.Near(_connectionObject2);
                this.activeNearConnection = _near;
                this.activeWallet = new _nearApiJs.WalletAccount(_near, _constants.DEFAULT_APP_NAME);
                _accountId2 = this.activeWallet.getAccountId();
                _context7.next = 35;
                return this.activeNearConnection.account(_accountId2);

              case 35:
                this.activeAccount = _context7.sent;
                return _context7.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: 'connection activated'
                }));

              case 39:
                return _context7.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'Only Browser or Node environment supported.'
                }));

              case 40:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function connect() {
        return _connect2.apply(this, arguments);
      }

      return connect;
    }()
    /**
     * Disconnects user. Removes the LocalStorage entry that
     * represents an authorized wallet account but leaves private keys intact.
     */

  }, {
    key: "disconnect",
    value: function disconnect() {
      var _this$activeWallet2;

      (_this$activeWallet2 = this.activeWallet) === null || _this$activeWallet2 === void 0 ? void 0 : _this$activeWallet2.signOut();
      this.activeNearConnection = undefined;
      this.activeAccount = undefined;
      return (0, _responseBuilder.formatResponse)({
        data: 'disconnected'
      });
    }
    /**
     * Connects to a wallet stored on local storage.
     * @param accountId the account identifier to connect.
     * @returns whether connection was successful or not.
     */

  }, {
    key: "connectTo",
    value: function () {
      var _connectTo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(accountId) {
        var _this2 = this;

        var _this$getLocalAccount, localAccounts, _getFullAccessPublicKey, localStorageKey, fullAccessKey;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!_browserOrNode.isNode) {
                  _context9.next = 2;
                  break;
                }

                return _context9.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'Node environment does not yet support the connectTo method.'
                }));

              case 2:
                // get localstorage accounts
                _this$getLocalAccount = this.getLocalAccounts(), localAccounts = _this$getLocalAccount.data; // does account user is trying to connect exists in storage?

                if (localAccounts[accountId]) {
                  _context9.next = 5;
                  break;
                }

                return _context9.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: false
                }));

              case 5:
                // get a full access public key with the largest nonce
                _getFullAccessPublicKey = /*#__PURE__*/function () {
                  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(accountId) {
                    var _yield$_this2$viewAcc, keysRequest, fullAccessKeys, highestNonceKey;

                    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                      while (1) {
                        switch (_context8.prev = _context8.next) {
                          case 0:
                            _context8.next = 2;
                            return _this2.viewAccessKeyList(accountId);

                          case 2:
                            _yield$_this2$viewAcc = _context8.sent;
                            keysRequest = _yield$_this2$viewAcc.data; // filter by full access keys

                            fullAccessKeys = keysRequest.keys.filter(function (acc) {
                              return acc.access_key.permission === 'FullAccess';
                            }); // get the highest nonce key

                            highestNonceKey = fullAccessKeys.reduce(function (acc, curr) {
                              var _acc$access_key, _curr$access_key;

                              return (acc === null || acc === void 0 ? void 0 : (_acc$access_key = acc.access_key) === null || _acc$access_key === void 0 ? void 0 : _acc$access_key.nonce) > (curr === null || curr === void 0 ? void 0 : (_curr$access_key = curr.access_key) === null || _curr$access_key === void 0 ? void 0 : _curr$access_key.nonce) ? acc : curr;
                            });
                            return _context8.abrupt("return", highestNonceKey);

                          case 7:
                          case "end":
                            return _context8.stop();
                        }
                      }
                    }, _callee8);
                  }));

                  return function _getFullAccessPublicKey(_x11) {
                    return _ref7.apply(this, arguments);
                  };
                }();

                if (!_browserOrNode.isBrowser) {
                  _context9.next = 14;
                  break;
                }

                localStorageKey = "".concat(_constants.DEFAULT_APP_NAME).concat(_constants.NEAR_LOCAL_STORAGE_KEY_SUFFIX);
                _context9.next = 10;
                return _getFullAccessPublicKey(accountId);

              case 10:
                fullAccessKey = _context9.sent;
                localStorage.setItem(localStorageKey, JSON.stringify({
                  accountId: accountId,
                  allKeys: [fullAccessKey.public_key]
                }));
                this.connect();
                return _context9.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: true
                }));

              case 14:
                return _context9.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: false
                }));

              case 15:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function connectTo(_x10) {
        return _connectTo.apply(this, arguments);
      }

      return connectTo;
    }()
    /**
     * Fetches connected account details.
     * @returns details of the current connection.
     */

  }, {
    key: "details",
    value: function () {
      var _details = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var _this$activeWallet3, _this$activeNearConne;

        var account, accountId, _yield$this$getSessio, keyPair, publicKey, balance, _yield$this$viewAcces, accessKey, allowance, contractName, data;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                account = (_this$activeWallet3 = this.activeWallet) === null || _this$activeWallet3 === void 0 ? void 0 : _this$activeWallet3.account();
                accountId = account === null || account === void 0 ? void 0 : account.accountId;
                _context10.next = 4;
                return this.getSessionKeyPair();

              case 4:
                _yield$this$getSessio = _context10.sent;
                keyPair = _yield$this$getSessio.data;

                if (!(!account || !accountId)) {
                  _context10.next = 8;
                  break;
                }

                return _context10.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'Account is undefined.'
                }));

              case 8:
                if (!(!keyPair || !accountId)) {
                  _context10.next = 10;
                  break;
                }

                return _context10.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: "No Key Pair for account ".concat(accountId)
                }));

              case 10:
                publicKey = keyPair.getPublicKey().toString();
                _context10.next = 13;
                return account.getAccountBalance();

              case 13:
                balance = _context10.sent;

                if (balance) {
                  _context10.next = 16;
                  break;
                }

                return _context10.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: ''
                }));

              case 16:
                _context10.next = 18;
                return this.viewAccessKey(accountId, publicKey);

              case 18:
                _yield$this$viewAcces = _context10.sent;
                accessKey = _yield$this$viewAcces.data;
                allowance = _nearApiJs.utils.format.formatNearAmount(accessKey.permission.FunctionCall.allowance);
                contractName = (_this$activeNearConne = this.activeNearConnection) === null || _this$activeNearConne === void 0 ? void 0 : _this$activeNearConne.config.contractName;
                data = {
                  accountId: accountId,
                  balance: _nearApiJs.utils.format.formatNearAmount(balance === null || balance === void 0 ? void 0 : balance.total, 2),
                  allowance: allowance,
                  contractName: contractName
                };
                return _context10.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: data
                }));

              case 24:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function details() {
        return _details.apply(this, arguments);
      }

      return details;
    }()
    /**
     * Transfer one or more tokens.
     * @param tokenIds The mapping of transfers, defined by: [[accountName1, tokenId1], [accountName2, tokenId2]]
     * @param contractName The contract name to transfer tokens from.
     */
    // TODO: need more checks on the tokenIds

  }, {
    key: "transfer",
    value: function () {
      var _transfer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(tokenIds, contractName) {
        var _this$activeWallet4, _this$activeWallet5;

        var account, accountId, contract;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                account = (_this$activeWallet4 = this.activeWallet) === null || _this$activeWallet4 === void 0 ? void 0 : _this$activeWallet4.account();
                accountId = (_this$activeWallet5 = this.activeWallet) === null || _this$activeWallet5 === void 0 ? void 0 : _this$activeWallet5.account().accountId;

                if (!(!account || !accountId)) {
                  _context11.next = 4;
                  break;
                }

                return _context11.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'Account is undefined.'
                }));

              case 4:
                if (contractName) {
                  _context11.next = 6;
                  break;
                }

                return _context11.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'No contract was provided.'
                }));

              case 6:
                contract = new _nearApiJs.Contract(account, contractName, {
                  viewMethods: this.constants.STORE_CONTRACT_VIEW_METHODS || _constants.STORE_CONTRACT_VIEW_METHODS,
                  changeMethods: this.constants.STORE_CONTRACT_CALL_METHODS || _constants.STORE_CONTRACT_CALL_METHODS
                }); // @ts-ignore: method does not exist on Contract type

                _context11.next = 9;
                return contract.nft_batch_transfer({
                  token_ids: tokenIds
                }, _constants.MAX_GAS, _constants.ONE_YOCTO);

              case 9:
                return _context11.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: true
                }));

              case 10:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function transfer(_x12, _x13) {
        return _transfer.apply(this, arguments);
      }

      return transfer;
    }()
    /**
     * Transfer one token.
     * @param tokenId The token id to transfer.
     * @param receiverId The account id to transfer to.
     * @param contractName The contract name to transfer tokens from.
     */
    // TODO: need more checks on the tokenIds

  }, {
    key: "simpleTransfer",
    value: function () {
      var _simpleTransfer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(tokenId, receiverId, contractName) {
        var _this$activeWallet6, _this$activeWallet7;

        var account, accountId, contract;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                account = (_this$activeWallet6 = this.activeWallet) === null || _this$activeWallet6 === void 0 ? void 0 : _this$activeWallet6.account();
                accountId = (_this$activeWallet7 = this.activeWallet) === null || _this$activeWallet7 === void 0 ? void 0 : _this$activeWallet7.account().accountId;

                if (!(!account || !accountId)) {
                  _context12.next = 4;
                  break;
                }

                return _context12.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'Account is undefined.'
                }));

              case 4:
                if (contractName) {
                  _context12.next = 6;
                  break;
                }

                return _context12.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'No contract was provided.'
                }));

              case 6:
                contract = new _nearApiJs.Contract(account, contractName, {
                  viewMethods: this.constants.STORE_CONTRACT_VIEW_METHODS || _constants.STORE_CONTRACT_VIEW_METHODS,
                  changeMethods: this.constants.STORE_CONTRACT_CALL_METHODS || _constants.STORE_CONTRACT_CALL_METHODS
                }); // @ts-ignore: method does not exist on Contract type

                _context12.next = 9;
                return contract.nft_transfer({
                  receiver_id: receiverId,
                  token_id: tokenId
                }, _constants.MAX_GAS, _constants.ONE_YOCTO);

              case 9:
                return _context12.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: true
                }));

              case 10:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function simpleTransfer(_x14, _x15, _x16) {
        return _simpleTransfer.apply(this, arguments);
      }

      return simpleTransfer;
    }()
    /**
     * Burn one or more tokens from the same contract.
     * @param contractName The contract name to burn tokens from.
     * @param tokenIds An array containing token ids to be burnt.
     */

  }, {
    key: "burn",
    value: function () {
      var _burn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(tokenIds) {
        var _this$activeWallet8, _this$activeWallet9;

        var account, accountId, contractName, isSameContract, contract, burnIds;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                account = (_this$activeWallet8 = this.activeWallet) === null || _this$activeWallet8 === void 0 ? void 0 : _this$activeWallet8.account();
                accountId = (_this$activeWallet9 = this.activeWallet) === null || _this$activeWallet9 === void 0 ? void 0 : _this$activeWallet9.account().accountId;
                contractName = tokenIds[0].split(':')[1];
                isSameContract = tokenIds.every(function (id) {
                  var split = id.split(':');
                  if (split.length === 2) return split[1] === contractName;
                  return false;
                });

                if (isSameContract) {
                  _context13.next = 6;
                  break;
                }

                return _context13.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'Tokens need to be all from the same contract.'
                }));

              case 6:
                if (!(!account || !accountId)) {
                  _context13.next = 8;
                  break;
                }

                return _context13.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'Account is undefined.'
                }));

              case 8:
                if (contractName) {
                  _context13.next = 10;
                  break;
                }

                return _context13.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'No contract was provided.'
                }));

              case 10:
                contract = new _nearApiJs.Contract(account, contractName, {
                  viewMethods: this.constants.STORE_CONTRACT_VIEW_METHODS || _constants.STORE_CONTRACT_VIEW_METHODS,
                  changeMethods: this.constants.STORE_CONTRACT_CALL_METHODS || _constants.STORE_CONTRACT_CALL_METHODS
                });
                burnIds = tokenIds.map(function (id) {
                  return id.split(':')[0];
                }); // @ts-ignore: method does not exist on Contract type

                _context13.next = 14;
                return contract.nft_batch_burn({
                  token_ids: burnIds
                }, _constants.MAX_GAS, _constants.ONE_YOCTO);

              case 14:
                return _context13.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: true
                }));

              case 15:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function burn(_x17) {
        return _burn.apply(this, arguments);
      }

      return burn;
    }()
    /**
     * List an item for sale in the market.
     * @param tokenId The token id list.
     * @param storeId The token store id (contract name).
     * @param price The listing price.
     * @param splitOwners List of splits.
     */

  }, {
    key: "batchList",
    value: function () {
      var _batchList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(tokenId, storeId, price, options) {
        var _this$activeWallet10, _this$activeWallet11, _options$autotransfer;

        var account, accountId, gas, contract, listCost;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                account = (_this$activeWallet10 = this.activeWallet) === null || _this$activeWallet10 === void 0 ? void 0 : _this$activeWallet10.account();
                accountId = (_this$activeWallet11 = this.activeWallet) === null || _this$activeWallet11 === void 0 ? void 0 : _this$activeWallet11.account().accountId;
                gas = !(options !== null && options !== void 0 && options.gas) ? _constants.MAX_GAS : new _bn["default"](options === null || options === void 0 ? void 0 : options.gas);

                if (!(!account || !accountId)) {
                  _context14.next = 5;
                  break;
                }

                return _context14.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'Account is undefined.'
                }));

              case 5:
                // TODO: Check if account owns the tokens that are trying to sell

                /*const token: Token = await this.api.fetchToken(
                  tokenId,
                  `${tokenId}:${storeId}`
                )
                 const isOwner = token.ownerId === accountId
                if (!isOwner) throw new Error('User does not own token.')*/
                contract = new _nearApiJs.Contract(account, storeId, {
                  viewMethods: this.constants.STORE_CONTRACT_VIEW_METHODS || _constants.STORE_CONTRACT_VIEW_METHODS,
                  changeMethods: this.constants.STORE_CONTRACT_CALL_METHODS || _constants.STORE_CONTRACT_CALL_METHODS
                }); // TODO: Checks on split_owners

                listCost = (0, _nearCosts.calculateListCost)(tokenId.length); // @ts-ignore: method does not exist on Contract type

                _context14.next = 9;
                return contract.nft_batch_approve({
                  token_ids: tokenId,
                  account_id: (options === null || options === void 0 ? void 0 : options.marketAddress) || this.constants.MARKET_ADDRESS || "0.".concat(this.constants.FACTORY_CONTRACT_NAME || _constants.FACTORY_CONTRACT_NAME),
                  msg: JSON.stringify({
                    price: price,
                    autotransfer: (_options$autotransfer = options === null || options === void 0 ? void 0 : options.autotransfer) !== null && _options$autotransfer !== void 0 ? _options$autotransfer : true
                  })
                }, gas, _nearApiJs.utils.format.parseNearAmount(listCost.toString()));

              case 9:
                return _context14.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: true
                }));

              case 10:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function batchList(_x18, _x19, _x20, _x21) {
        return _batchList.apply(this, arguments);
      }

      return batchList;
    }()
    /**
     * List an item for sale in the market.
     * @param tokenId The token id.
     * @param storeId The token store id (contract name).
     * @param price The listing price.
     * @param splitOwners List of splits.
     */

  }, {
    key: "list",
    value: function () {
      var _list = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(tokenId, storeId, price, options) {
        var _this$activeWallet12, _this$activeWallet13, _options$autotransfer2;

        var account, accountId, gas, contract, listCost;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                account = (_this$activeWallet12 = this.activeWallet) === null || _this$activeWallet12 === void 0 ? void 0 : _this$activeWallet12.account();
                accountId = (_this$activeWallet13 = this.activeWallet) === null || _this$activeWallet13 === void 0 ? void 0 : _this$activeWallet13.account().accountId;
                gas = !(options !== null && options !== void 0 && options.gas) ? _constants.MAX_GAS : new _bn["default"](options === null || options === void 0 ? void 0 : options.gas);

                if (!(!account || !accountId)) {
                  _context15.next = 5;
                  break;
                }

                return _context15.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'Account is undefined.'
                }));

              case 5:
                // TODO: Check if account owns the tokens that are trying to sell

                /*const token: Token = await this.api.fetchToken(
                  tokenId,
                  `${tokenId}:${storeId}`
                )
                 const isOwner = token.ownerId === accountId
                if (!isOwner) throw new Error('User does not own token.')*/
                contract = new _nearApiJs.Contract(account, storeId, {
                  viewMethods: this.constants.STORE_CONTRACT_VIEW_METHODS || _constants.STORE_CONTRACT_VIEW_METHODS,
                  changeMethods: this.constants.STORE_CONTRACT_CALL_METHODS || _constants.STORE_CONTRACT_CALL_METHODS
                }); // TODO: Checks on split_owners

                listCost = (0, _nearCosts.calculateListCost)(1); // @ts-ignore: method does not exist on Contract type

                _context15.next = 9;
                return contract.nft_approve({
                  token_id: tokenId,
                  account_id: (options === null || options === void 0 ? void 0 : options.marketAddress) || this.constants.MARKET_ADDRESS || "0.".concat(this.constants.FACTORY_CONTRACT_NAME || _constants.FACTORY_CONTRACT_NAME),
                  msg: JSON.stringify({
                    price: price,
                    autotransfer: (_options$autotransfer2 = options === null || options === void 0 ? void 0 : options.autotransfer) !== null && _options$autotransfer2 !== void 0 ? _options$autotransfer2 : true
                  })
                }, gas, _nearApiJs.utils.format.parseNearAmount(listCost.toString()));

              case 9:
                return _context15.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: true
                }));

              case 10:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function list(_x22, _x23, _x24, _x25) {
        return _list.apply(this, arguments);
      }

      return list;
    }()
  }, {
    key: "revokeAccount",
    value: function () {
      var _revokeAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(tokenId, storeId, accountRevokeId) {
        var _this$activeWallet14, _this$activeWallet15;

        var account, accountId, contract;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                account = (_this$activeWallet14 = this.activeWallet) === null || _this$activeWallet14 === void 0 ? void 0 : _this$activeWallet14.account();
                accountId = (_this$activeWallet15 = this.activeWallet) === null || _this$activeWallet15 === void 0 ? void 0 : _this$activeWallet15.account().accountId;

                if (!(!account || !accountId)) {
                  _context16.next = 4;
                  break;
                }

                return _context16.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'Account is undefined.'
                }));

              case 4:
                contract = new _nearApiJs.Contract(account, storeId, {
                  viewMethods: this.constants.STORE_CONTRACT_VIEW_METHODS || _constants.STORE_CONTRACT_VIEW_METHODS,
                  changeMethods: this.constants.STORE_CONTRACT_CALL_METHODS || _constants.STORE_CONTRACT_CALL_METHODS
                }); // TODO: converge mainnet and testnet

                if (!(this.networkName === 'testnet')) {
                  _context16.next = 10;
                  break;
                }

                _context16.next = 8;
                return contract.nft_revoke({
                  token_id: tokenId,
                  account_id: accountRevokeId
                }, _constants.MAX_GAS, _constants.ONE_YOCTO);

              case 8:
                _context16.next = 12;
                break;

              case 10:
                _context16.next = 12;
                return contract.nft_revoke({
                  token_id: tokenId,
                  account_id: accountRevokeId
                }, _constants.MAX_GAS);

              case 12:
                return _context16.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: true
                }));

              case 13:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function revokeAccount(_x26, _x27, _x28) {
        return _revokeAccount.apply(this, arguments);
      }

      return revokeAccount;
    }()
  }, {
    key: "revokeAllAccounts",
    value: function () {
      var _revokeAllAccounts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(tokenId, storeId) {
        var _this$activeWallet16, _this$activeWallet17;

        var account, accountId, GAS, contract;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                account = (_this$activeWallet16 = this.activeWallet) === null || _this$activeWallet16 === void 0 ? void 0 : _this$activeWallet16.account();
                accountId = (_this$activeWallet17 = this.activeWallet) === null || _this$activeWallet17 === void 0 ? void 0 : _this$activeWallet17.account().accountId;
                GAS = new _bn["default"]('300000000000000');

                if (!(!account || !accountId)) {
                  _context17.next = 5;
                  break;
                }

                return _context17.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'Account is undefined.'
                }));

              case 5:
                contract = new _nearApiJs.Contract(account, storeId, {
                  viewMethods: this.constants.STORE_CONTRACT_VIEW_METHODS || _constants.STORE_CONTRACT_VIEW_METHODS,
                  changeMethods: this.constants.STORE_CONTRACT_CALL_METHODS || _constants.STORE_CONTRACT_CALL_METHODS
                }); // TODO: converge mainnet and testnet

                if (!(this.networkName === 'testnet')) {
                  _context17.next = 11;
                  break;
                }

                _context17.next = 9;
                return contract.nft_revoke_all({
                  token_id: tokenId
                }, GAS, _constants.ONE_YOCTO);

              case 9:
                _context17.next = 13;
                break;

              case 11:
                _context17.next = 13;
                return contract.nft_revoke_all({
                  token_id: tokenId
                }, GAS);

              case 13:
                return _context17.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: true
                }));

              case 14:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function revokeAllAccounts(_x29, _x30) {
        return _revokeAllAccounts.apply(this, arguments);
      }

      return revokeAllAccounts;
    }()
    /**
     * Make an offer to a token from a group.
     * @param groupId
     * @param price
     */

  }, {
    key: "makeGroupOffer",
    value: function () {
      var _makeGroupOffer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(groupId, price, options) {
        var _this$activeWallet18, _this$activeWallet19;

        var account, accountId, gas, _yield$this$api$fetch, list, error, contract, setPrice;

        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                account = (_this$activeWallet18 = this.activeWallet) === null || _this$activeWallet18 === void 0 ? void 0 : _this$activeWallet18.account();
                accountId = (_this$activeWallet19 = this.activeWallet) === null || _this$activeWallet19 === void 0 ? void 0 : _this$activeWallet19.account().accountId;
                gas = !(options !== null && options !== void 0 && options.gas) ? _constants.MAX_GAS : new _bn["default"](options === null || options === void 0 ? void 0 : options.gas);

                if (!(!account || !accountId)) {
                  _context18.next = 5;
                  break;
                }

                return _context18.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'Account is undefined.'
                }));

              case 5:
                if (!groupId) (0, _responseBuilder.formatResponse)({
                  error: 'Please provide a groupId'
                });

                if (this.api) {
                  _context18.next = 8;
                  break;
                }

                return _context18.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'API is not defined.'
                }));

              case 8:
                _context18.next = 10;
                return this.api.fetchListById(groupId);

              case 10:
                _yield$this$api$fetch = _context18.sent;
                list = _yield$this$api$fetch.data;
                error = _yield$this$api$fetch.error;

                if (!error) {
                  _context18.next = 15;
                  break;
                }

                return _context18.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: error
                }));

              case 15:
                contract = new _nearApiJs.Contract(account, (options === null || options === void 0 ? void 0 : options.marketAddress) || this.constants.MARKET_ADDRESS || "0.".concat(this.constants.FACTORY_CONTRACT_NAME || _constants.FACTORY_CONTRACT_NAME), {
                  viewMethods: this.constants.MARKET_CONTRACT_VIEW_METHODS || _constants.MARKET_CONTRACT_VIEW_METHODS,
                  changeMethods: this.constants.MARKET_CONTRACT_CALL_METHODS || _constants.MARKET_CONTRACT_CALL_METHODS
                });
                setPrice = price || list.price; // @ts-ignore: method does not exist on Contract type

                _context18.next = 19;
                return contract.make_offer({
                  token_key: list.token.id,
                  price: setPrice,
                  timeout: {
                    Hours: _constants.TWENTY_FOUR
                  }
                }, gas, setPrice);

              case 19:
                return _context18.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: true
                }));

              case 20:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function makeGroupOffer(_x31, _x32, _x33) {
        return _makeGroupOffer.apply(this, arguments);
      }

      return makeGroupOffer;
    }()
    /**
     * Make an offer to multiple tokens.
     * @param tokenIds: Array of tokenIds
     * @param price: Price of each token
     */

  }, {
    key: "batchMakeOffer",
    value: function () {
      var _batchMakeOffer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(tokenIds, prices, options) {
        var _this$activeWallet20, _this$activeWallet21;

        var account, accountId, gas, contract, totalPrice;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                account = (_this$activeWallet20 = this.activeWallet) === null || _this$activeWallet20 === void 0 ? void 0 : _this$activeWallet20.account();
                accountId = (_this$activeWallet21 = this.activeWallet) === null || _this$activeWallet21 === void 0 ? void 0 : _this$activeWallet21.account().accountId;
                gas = !(options !== null && options !== void 0 && options.gas) ? _constants.MAX_GAS : new _bn["default"](options === null || options === void 0 ? void 0 : options.gas);

                if (!(!account || !accountId)) {
                  _context19.next = 5;
                  break;
                }

                return _context19.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'Account is undefined.'
                }));

              case 5:
                contract = new _nearApiJs.Contract(account, (options === null || options === void 0 ? void 0 : options.marketAddress) || this.constants.MARKET_ADDRESS || "0.".concat(this.constants.FACTORY_CONTRACT_NAME || _constants.FACTORY_CONTRACT_NAME), {
                  viewMethods: this.constants.MARKET_CONTRACT_VIEW_METHODS || _constants.MARKET_CONTRACT_VIEW_METHODS,
                  changeMethods: this.constants.MARKET_CONTRACT_CALL_METHODS || _constants.MARKET_CONTRACT_CALL_METHODS
                });
                totalPrice = prices.reduce(function (acc, curr) {
                  return acc.add(new _bn["default"](curr));
                }, new _bn["default"](0)); // @ts-ignore: method does not exist on Contract type

                _context19.next = 9;
                return contract.make_offer({
                  token_key: tokenIds,
                  price: prices,
                  timeout: Array(tokenIds.length).fill({
                    Hours: _constants.TWENTY_FOUR
                  })
                }, gas, totalPrice.toString());

              case 9:
                return _context19.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: true
                }));

              case 10:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function batchMakeOffer(_x34, _x35, _x36) {
        return _batchMakeOffer.apply(this, arguments);
      }

      return batchMakeOffer;
    }()
    /**
     * Make an offer to a token.
     * @param tokenId
     * @param price
     */

  }, {
    key: "makeOffer",
    value: function () {
      var _makeOffer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(tokenId, price, options) {
        var _this$activeWallet22, _this$activeWallet23;

        var account, accountId, gas, contract;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                account = (_this$activeWallet22 = this.activeWallet) === null || _this$activeWallet22 === void 0 ? void 0 : _this$activeWallet22.account();
                accountId = (_this$activeWallet23 = this.activeWallet) === null || _this$activeWallet23 === void 0 ? void 0 : _this$activeWallet23.account().accountId;
                gas = !(options !== null && options !== void 0 && options.gas) ? _constants.MAX_GAS : new _bn["default"](options === null || options === void 0 ? void 0 : options.gas);

                if (!(!account || !accountId)) {
                  _context20.next = 5;
                  break;
                }

                return _context20.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'Account is undefined.'
                }));

              case 5:
                if (tokenId) {
                  _context20.next = 7;
                  break;
                }

                return _context20.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'Please provide a tokenId'
                }));

              case 7:
                contract = new _nearApiJs.Contract(account, (options === null || options === void 0 ? void 0 : options.marketAddress) || this.constants.MARKET_ADDRESS || "0.".concat(this.constants.FACTORY_CONTRACT_NAME || _constants.FACTORY_CONTRACT_NAME), {
                  viewMethods: this.constants.MARKET_CONTRACT_VIEW_METHODS || _constants.MARKET_CONTRACT_VIEW_METHODS,
                  changeMethods: this.constants.MARKET_CONTRACT_CALL_METHODS || _constants.MARKET_CONTRACT_CALL_METHODS
                }); // @ts-ignore: method does not exist on Contract type

                _context20.next = 10;
                return contract.make_offer({
                  token_key: [tokenId],
                  price: [price],
                  timeout: [{
                    Hours: _constants.TWENTY_FOUR
                  }]
                }, gas, price);

              case 10:
                return _context20.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: true
                }));

              case 11:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function makeOffer(_x37, _x38, _x39) {
        return _makeOffer.apply(this, arguments);
      }

      return makeOffer;
    }()
    /**
     * Make an offer to a token.
     * @param tokenId
     * @param price
     */

  }, {
    key: "acceptAndTransfer",
    value: function () {
      var _acceptAndTransfer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(tokenId, options) {
        var _this$activeWallet24, _this$activeWallet25;

        var account, accountId, gas, contract;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                account = (_this$activeWallet24 = this.activeWallet) === null || _this$activeWallet24 === void 0 ? void 0 : _this$activeWallet24.account();
                accountId = (_this$activeWallet25 = this.activeWallet) === null || _this$activeWallet25 === void 0 ? void 0 : _this$activeWallet25.account().accountId;
                gas = !(options !== null && options !== void 0 && options.gas) ? _constants.MAX_GAS : new _bn["default"](options === null || options === void 0 ? void 0 : options.gas);

                if (!(!account || !accountId)) {
                  _context21.next = 5;
                  break;
                }

                return _context21.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'Account is undefined.'
                }));

              case 5:
                if (tokenId) {
                  _context21.next = 7;
                  break;
                }

                return _context21.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'Please provide a tokenId'
                }));

              case 7:
                contract = new _nearApiJs.Contract(account, (options === null || options === void 0 ? void 0 : options.marketAddress) || this.constants.MARKET_ADDRESS || "0.".concat(this.constants.FACTORY_CONTRACT_NAME || _constants.FACTORY_CONTRACT_NAME), {
                  viewMethods: this.constants.MARKET_CONTRACT_VIEW_METHODS || _constants.MARKET_CONTRACT_VIEW_METHODS,
                  changeMethods: this.constants.MARKET_CONTRACT_CALL_METHODS || _constants.MARKET_CONTRACT_CALL_METHODS
                }); // @ts-ignore: method does not exist on Contract type

                _context21.next = 10;
                return contract.accept_and_transfer({
                  token_key: tokenId
                }, gas, _constants.ONE_YOCTO);

              case 10:
                return _context21.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: true
                }));

              case 11:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function acceptAndTransfer(_x40, _x41) {
        return _acceptAndTransfer.apply(this, arguments);
      }

      return acceptAndTransfer;
    }()
    /**
     *  Withdraw the escrow deposited for an offer.
     * @param tokenKey The token key. `<tokenId>:<contractName>`
     */

  }, {
    key: "withdrawOffer",
    value: function () {
      var _withdrawOffer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(tokenKey, options) {
        var _this$activeWallet26, _this$activeWallet27;

        var account, accountId, gas, contract;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                account = (_this$activeWallet26 = this.activeWallet) === null || _this$activeWallet26 === void 0 ? void 0 : _this$activeWallet26.account();
                accountId = (_this$activeWallet27 = this.activeWallet) === null || _this$activeWallet27 === void 0 ? void 0 : _this$activeWallet27.account().accountId;
                gas = !(options !== null && options !== void 0 && options.gas) ? _constants.MAX_GAS : new _bn["default"](options === null || options === void 0 ? void 0 : options.gas);

                if (!(!account || !accountId)) {
                  _context22.next = 5;
                  break;
                }

                return _context22.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'Account is undefined.'
                }));

              case 5:
                contract = new _nearApiJs.Contract(account, (options === null || options === void 0 ? void 0 : options.marketAddress) || this.constants.MARKET_ADDRESS || "0.".concat(this.constants.FACTORY_CONTRACT_NAME || _constants.FACTORY_CONTRACT_NAME), {
                  viewMethods: this.constants.MARKET_CONTRACT_VIEW_METHODS || _constants.MARKET_CONTRACT_VIEW_METHODS,
                  changeMethods: this.constants.MARKET_CONTRACT_CALL_METHODS || _constants.MARKET_CONTRACT_CALL_METHODS
                }); // @ts-ignore: method does not exist on Contract type

                _context22.next = 8;
                return contract.withdraw_offer({
                  token_key: tokenKey
                }, gas);

              case 8:
                return _context22.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: true
                }));

              case 9:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function withdrawOffer(_x42, _x43) {
        return _withdrawOffer.apply(this, arguments);
      }

      return withdrawOffer;
    }()
    /**
     * Creates a store
     * @param storeId Store name
     * @param symbol Store symbol
     */

  }, {
    key: "deployStore",
    value: function () {
      var _deployStore = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(storeId, symbol, options) {
        var _this$activeWallet28, _this$activeWallet29, _options$icon;

        var account, accountId, gas, contract, storeData, attachedDeposit;
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                account = (_this$activeWallet28 = this.activeWallet) === null || _this$activeWallet28 === void 0 ? void 0 : _this$activeWallet28.account();
                accountId = (_this$activeWallet29 = this.activeWallet) === null || _this$activeWallet29 === void 0 ? void 0 : _this$activeWallet29.account().accountId;
                gas = !(options !== null && options !== void 0 && options.gas) ? _constants.MAX_GAS : new _bn["default"](options === null || options === void 0 ? void 0 : options.gas);

                if (!(!account || !accountId)) {
                  _context23.next = 5;
                  break;
                }

                return _context23.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'Account is undefined.'
                }));

              case 5:
                // TODO: regex check inputs (storeId and symbol)
                contract = new _nearApiJs.Contract(account, this.constants.FACTORY_CONTRACT_NAME || _constants.FACTORY_CONTRACT_NAME, {
                  viewMethods: this.constants.FACTORY_CONTRACT_VIEW_METHODS || _constants.FACTORY_CONTRACT_VIEW_METHODS,
                  changeMethods: this.constants.FACTORY_CONTRACT_CALL_METHODS || _constants.FACTORY_CONTRACT_CALL_METHODS
                });
                storeData = {
                  owner_id: accountId,
                  metadata: {
                    spec: 'nft-1.0.0',
                    name: storeId.replace(/[^a-z0-9]+/gim, '').toLowerCase(),
                    symbol: symbol.replace(/[^a-z0-9]+/gim, '').toLowerCase(),
                    icon: (_options$icon = options === null || options === void 0 ? void 0 : options.icon) !== null && _options$icon !== void 0 ? _options$icon : _constants.MINTBASE_32x32_BASE64_DARK_LOGO,
                    base_uri: this.constants.BASE_ARWEAVE_URI || _constants.BASE_ARWEAVE_URI,
                    reference: null,
                    reference_hash: null
                  }
                };
                attachedDeposit = !(options !== null && options !== void 0 && options.attachedDeposit) ? _constants.DEPLOY_STORE_COST : new _bn["default"](options === null || options === void 0 ? void 0 : options.attachedDeposit); // @ts-ignore: method does not exist on Contract type

                _context23.next = 10;
                return contract.create_store(storeData, gas, attachedDeposit);

              case 10:
                return _context23.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: true
                }));

              case 11:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function deployStore(_x44, _x45, _x46) {
        return _deployStore.apply(this, arguments);
      }

      return deployStore;
    }()
    /**
     * Transfers ownership of a store
     * @param newOwner
     * @param keepOldMinters
     */

  }, {
    key: "transferStoreOwnership",
    value: function () {
      var _transferStoreOwnership = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(newOwner, contractName, options) {
        var _this$activeWallet30, _this$activeWallet31;

        var account, accountId, contract, keepOldMinters;
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                account = (_this$activeWallet30 = this.activeWallet) === null || _this$activeWallet30 === void 0 ? void 0 : _this$activeWallet30.account();
                accountId = (_this$activeWallet31 = this.activeWallet) === null || _this$activeWallet31 === void 0 ? void 0 : _this$activeWallet31.account().accountId;

                if (!(!account || !accountId)) {
                  _context24.next = 4;
                  break;
                }

                return _context24.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'Account is undefined.'
                }));

              case 4:
                if (contractName) {
                  _context24.next = 6;
                  break;
                }

                return _context24.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'No contract was provided.'
                }));

              case 6:
                contract = new _nearApiJs.Contract(account, contractName, {
                  viewMethods: this.constants.STORE_CONTRACT_VIEW_METHODS || _constants.STORE_CONTRACT_VIEW_METHODS,
                  changeMethods: this.constants.STORE_CONTRACT_CALL_METHODS || _constants.STORE_CONTRACT_CALL_METHODS
                });
                keepOldMinters = (options === null || options === void 0 ? void 0 : options.keepOldMinters) || true; // @ts-ignore: method does not exist on Contract type

                _context24.next = 10;
                return contract.transfer_store_ownership({
                  new_owner: newOwner,
                  keep_old_minters: keepOldMinters
                }, _constants.MAX_GAS, _constants.ONE_YOCTO);

              case 10:
                return _context24.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: true
                }));

              case 11:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function transferStoreOwnership(_x47, _x48, _x49) {
        return _transferStoreOwnership.apply(this, arguments);
      }

      return transferStoreOwnership;
    }()
    /**
     * Mint a token
     * @param amount The number of tokens to mint.
     * @param contractName The contract in which tokens will be minted.
     */

  }, {
    key: "mint",
    value: function () {
      var _mint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(amount, contractName, royalties, splits, category) {
        var _this$activeWallet32, _this$activeWallet33;

        var account, accountId, contract, _yield$this$minter$ge, metadataId, obj;

        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                account = (_this$activeWallet32 = this.activeWallet) === null || _this$activeWallet32 === void 0 ? void 0 : _this$activeWallet32.account();
                accountId = (_this$activeWallet33 = this.activeWallet) === null || _this$activeWallet33 === void 0 ? void 0 : _this$activeWallet33.account().accountId;

                if (!(!account || !accountId)) {
                  _context25.next = 4;
                  break;
                }

                return _context25.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'Account is undefined.'
                }));

              case 4:
                if (contractName) {
                  _context25.next = 6;
                  break;
                }

                return _context25.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'No contract was provided.'
                }));

              case 6:
                contract = new _nearApiJs.Contract(account, contractName, {
                  viewMethods: this.constants.STORE_CONTRACT_VIEW_METHODS || _constants.STORE_CONTRACT_VIEW_METHODS,
                  changeMethods: this.constants.STORE_CONTRACT_CALL_METHODS || _constants.STORE_CONTRACT_CALL_METHODS
                }); // TODO: Check if minter has a valid object to mint.

                if (this.minter) {
                  _context25.next = 9;
                  break;
                }

                return _context25.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'Minter not defined.'
                }));

              case 9:
                _context25.next = 11;
                return this.minter.getMetadataId();

              case 11:
                _yield$this$minter$ge = _context25.sent;
                metadataId = _yield$this$minter$ge.data;
                obj = {
                  owner_id: accountId,
                  metadata: {
                    reference: metadataId,
                    // TODO: check if category is lowercase
                    extra: !category ? null : category
                  },
                  num_to_mint: amount,
                  royalty_args: !royalties ? null : {
                    split_between: royalties,
                    percentage: _constants.DEFAULT_ROYALTY_PERCENT
                  },
                  split_owners: splits || null
                }; // @ts-ignore: method does not exist on Contract type

                _context25.next = 16;
                return contract.nft_batch_mint(obj, _constants.MAX_GAS, _constants.ONE_YOCTO);

              case 16:
                return _context25.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: true
                }));

              case 17:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function mint(_x50, _x51, _x52, _x53, _x54) {
        return _mint.apply(this, arguments);
      }

      return mint;
    }()
    /**
     * Mint more pieces of tokens of a thing.
     * @param amount The number of tokens to mint.
     * @param id The thing id
     * @param splits The contract in which tokens will be minted.
     */

  }, {
    key: "mintMore",
    value: function () {
      var _mintMore = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(amount, id, splits) {
        var _this$activeWallet34, _this$activeWallet35;

        var account, accountId, _yield$this$api$custo, data, error, _thing, thing, contractName, memo, metaId, token, contract, _royalties, obj;

        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                account = (_this$activeWallet34 = this.activeWallet) === null || _this$activeWallet34 === void 0 ? void 0 : _this$activeWallet34.account();
                accountId = (_this$activeWallet35 = this.activeWallet) === null || _this$activeWallet35 === void 0 ? void 0 : _this$activeWallet35.account().accountId;

                if (!(!account || !accountId)) {
                  _context26.next = 4;
                  break;
                }

                throw new Error('Account is undefined.');

              case 4:
                if (this.api) {
                  _context26.next = 6;
                  break;
                }

                throw new Error('API is not defined.');

              case 6:
                _context26.next = 8;
                return this.api.custom("query GET_THING_BY_ID($id: String!) {\n      thing(where: {id: {_eq: $id}}) {\n        metaId\n        storeId\n        memo\n        tokens {\n          royaltyPercent\n          royaltys {\n            account\n            percent\n          }\n        }\n      }\n    }\n    ", {
                  id: id
                });

              case 8:
                _yield$this$api$custo = _context26.sent;
                data = _yield$this$api$custo.data;
                error = _yield$this$api$custo.error;
                _thing = data.thing;

                if (!(error || _thing.length === 0)) {
                  _context26.next = 14;
                  break;
                }

                return _context26.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'Thing does not exist.'
                }));

              case 14:
                thing = _thing[0];

                if (!(thing.tokens.length === 0)) {
                  _context26.next = 17;
                  break;
                }

                return _context26.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'Thing does not have tokens.'
                }));

              case 17:
                contractName = thing.storeId;
                memo = thing.memo;
                metaId = thing.metaId;
                token = thing.tokens[0];
                contract = new _nearApiJs.Contract(account, contractName, {
                  viewMethods: this.constants.STORE_CONTRACT_VIEW_METHODS || _constants.STORE_CONTRACT_VIEW_METHODS,
                  changeMethods: this.constants.STORE_CONTRACT_CALL_METHODS || _constants.STORE_CONTRACT_CALL_METHODS
                });
                _royalties = token.royaltys.reduce(function (accumulator, _ref8) {
                  var account = _ref8.account,
                      percent = _ref8.percent;
                  return _objectSpread(_objectSpread({}, accumulator), {}, _defineProperty({}, account, percent));
                }, {});
                obj = {
                  owner_id: accountId,
                  metadata: {
                    reference: metaId,
                    extra: memo
                  },
                  num_to_mint: amount,
                  royalty_args: Object.keys(_royalties).length > 0 ? {
                    split_between: _royalties,
                    percentage: token.royaltyPercent
                  } : null,
                  split_owners: splits || null
                }; // @ts-ignore: method does not exist on Contract type

                _context26.next = 26;
                return contract.nft_batch_mint(obj, _constants.MAX_GAS, _constants.ONE_YOCTO);

              case 26:
                return _context26.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: true
                }));

              case 27:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function mintMore(_x55, _x56, _x57) {
        return _mintMore.apply(this, arguments);
      }

      return mintMore;
    }()
  }, {
    key: "grantMinter",
    value: function () {
      var _grantMinter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(minterAccountId, contractName) {
        var _this$activeWallet36, _this$activeWallet37;

        var account, accountId, contract;
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                account = (_this$activeWallet36 = this.activeWallet) === null || _this$activeWallet36 === void 0 ? void 0 : _this$activeWallet36.account();
                accountId = (_this$activeWallet37 = this.activeWallet) === null || _this$activeWallet37 === void 0 ? void 0 : _this$activeWallet37.account().accountId;

                if (!(!account || !accountId)) {
                  _context27.next = 4;
                  break;
                }

                return _context27.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'Account is undefined.'
                }));

              case 4:
                if (contractName) {
                  _context27.next = 6;
                  break;
                }

                return _context27.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'No contract was provided.'
                }));

              case 6:
                contract = new _nearApiJs.Contract(account, contractName, {
                  viewMethods: this.constants.STORE_CONTRACT_VIEW_METHODS || _constants.STORE_CONTRACT_VIEW_METHODS,
                  changeMethods: this.constants.STORE_CONTRACT_CALL_METHODS || _constants.STORE_CONTRACT_CALL_METHODS
                }); // @ts-ignore: method does not exist on Contract type

                _context27.next = 9;
                return contract.grant_minter({
                  account_id: minterAccountId
                }, _constants.MAX_GAS, _constants.ONE_YOCTO);

              case 9:
                return _context27.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: true
                }));

              case 10:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function grantMinter(_x58, _x59) {
        return _grantMinter.apply(this, arguments);
      }

      return grantMinter;
    }()
  }, {
    key: "revokeMinter",
    value: function () {
      var _revokeMinter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(minterAccountId, contractName) {
        var _this$activeWallet38, _this$activeWallet39;

        var account, accountId, contract;
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                account = (_this$activeWallet38 = this.activeWallet) === null || _this$activeWallet38 === void 0 ? void 0 : _this$activeWallet38.account();
                accountId = (_this$activeWallet39 = this.activeWallet) === null || _this$activeWallet39 === void 0 ? void 0 : _this$activeWallet39.account().accountId;

                if (!(!account || !accountId)) {
                  _context28.next = 4;
                  break;
                }

                return _context28.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'Account is undefined.'
                }));

              case 4:
                if (contractName) {
                  _context28.next = 6;
                  break;
                }

                return _context28.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'No contract was provided.'
                }));

              case 6:
                contract = new _nearApiJs.Contract(account, contractName, {
                  viewMethods: this.constants.STORE_CONTRACT_VIEW_METHODS || _constants.STORE_CONTRACT_VIEW_METHODS,
                  changeMethods: this.constants.STORE_CONTRACT_CALL_METHODS || _constants.STORE_CONTRACT_CALL_METHODS
                }); // @ts-ignore: method does not exist on Contract type

                _context28.next = 9;
                return contract.revoke_minter({
                  account_id: minterAccountId
                }, _constants.MAX_GAS, _constants.ONE_YOCTO);

              case 9:
                return _context28.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: true
                }));

              case 10:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function revokeMinter(_x60, _x61) {
        return _revokeMinter.apply(this, arguments);
      }

      return revokeMinter;
    }()
  }, {
    key: "setSessionKeyPair",
    value: function () {
      var _setSessionKeyPair = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(accountId, privateKey) {
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                if (this.keyStore) {
                  _context29.next = 2;
                  break;
                }

                return _context29.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'KeyStore not defined.'
                }));

              case 2:
                this.keyStore.setKey(this.networkName, accountId, _nearApiJs.KeyPair.fromString(privateKey));
                return _context29.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: this.keyStore
                }));

              case 4:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));

      function setSessionKeyPair(_x62, _x63) {
        return _setSessionKeyPair.apply(this, arguments);
      }

      return setSessionKeyPair;
    }()
  }, {
    key: "getSessionKeyPair",
    value: function () {
      var _getSessionKeyPair = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30() {
        var _this$activeWallet40, _this$keyStore;

        var accountId, data;
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                accountId = (_this$activeWallet40 = this.activeWallet) === null || _this$activeWallet40 === void 0 ? void 0 : _this$activeWallet40.getAccountId();

                if (accountId) {
                  _context30.next = 3;
                  break;
                }

                return _context30.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: _constants.ERROR_MESSAGES.undefinedAccountId
                }));

              case 3:
                if (this.keyStore) {
                  _context30.next = 5;
                  break;
                }

                return _context30.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: _constants.ERROR_MESSAGES.undefinedKeyStore
                }));

              case 5:
                _context30.next = 7;
                return (_this$keyStore = this.keyStore) === null || _this$keyStore === void 0 ? void 0 : _this$keyStore.getKey(this.networkName, accountId);

              case 7:
                data = _context30.sent;
                return _context30.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: data
                }));

              case 9:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));

      function getSessionKeyPair() {
        return _getSessionKeyPair.apply(this, arguments);
      }

      return getSessionKeyPair;
    }()
  }, {
    key: "signMessage",
    value: function () {
      var _signMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(message) {
        var _this$activeAccount;

        var _yield$this$getSessio2, keyPair, error, accountId, arrayBuffer, encodedMessage, _keyPair$sign, signature, publicKey;

        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                if (this.isConnected()) {
                  _context31.next = 2;
                  break;
                }

                return _context31.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: _constants.ERROR_MESSAGES.walletNotConnected
                }));

              case 2:
                _context31.next = 4;
                return this.getSessionKeyPair();

              case 4:
                _yield$this$getSessio2 = _context31.sent;
                keyPair = _yield$this$getSessio2.data;
                error = _yield$this$getSessio2.error;

                if (!error) {
                  _context31.next = 9;
                  break;
                }

                return _context31.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: _constants.ERROR_MESSAGES.invalidKeyPair
                }));

              case 9:
                accountId = (_this$activeAccount = this.activeAccount) === null || _this$activeAccount === void 0 ? void 0 : _this$activeAccount.accountId;

                if (accountId) {
                  _context31.next = 12;
                  break;
                }

                return _context31.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: _constants.ERROR_MESSAGES.undefinedAccountId
                }));

              case 12:
                arrayBuffer = new TextEncoder().encode(message).buffer;
                encodedMessage = new Uint8Array(arrayBuffer);
                _keyPair$sign = keyPair.sign(encodedMessage), signature = _keyPair$sign.signature, publicKey = _keyPair$sign.publicKey;
                return _context31.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: {
                    signature: Array.from(signature),
                    publicKey: Array.from(publicKey.data),
                    publicKey_str: keyPair.getPublicKey().toString(),
                    accountId: accountId
                  }
                }));

              case 16:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));

      function signMessage(_x64) {
        return _signMessage.apply(this, arguments);
      }

      return signMessage;
    }()
  }, {
    key: "verifySignature",
    value: function () {
      var _verifySignature = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(requestBody) {
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                return _context32.abrupt("return", _tweetnacl.sign.detached.verify((0, _message.messageEncode)(requestBody.message), new Uint8Array(requestBody.signature), new Uint8Array(requestBody.publicKey)));

              case 1:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32);
      }));

      function verifySignature(_x65) {
        return _verifySignature.apply(this, arguments);
      }

      return verifySignature;
    }()
  }, {
    key: "getKeyStore",
    value: function getKeyStore() {
      if (_browserOrNode.isNode) return new _nearApiJs.keyStores.InMemoryKeyStore();
      if (_browserOrNode.isBrowser) return new _nearApiJs.keyStores.BrowserLocalStorageKeyStore();
      throw new Error('Runtime environment has to be Node or Browser');
    } // private getKeyPairFromLocalstorage() {}

    /**
     * Fetch local storage connections
     */

  }, {
    key: "getLocalAccounts",
    value: function getLocalAccounts() {
      var regex = /near-api-js:keystore:/;
      var keys = Object.keys(localStorage);
      var matches = keys.filter(function (key) {
        return regex.exec(key) !== null;
      });
      var accounts = {};
      matches.forEach(function (key) {
        var accountId = key.split(':')[2];
        accounts = _objectSpread(_objectSpread({}, accounts), {}, _defineProperty({}, accountId, {
          accountId: accountId,
          contractName: '' // TODO: get contractName connection

        }));
      });
      return (0, _responseBuilder.formatResponse)({
        data: accounts
      });
    }
    /**
     * Fetch transaction result given a transaction hash.
     * @param txHash the transaction's hash
     * @returns the transaction result
     */

  }, {
    key: "fetchTransactionResult",
    value: function () {
      var _fetchTransactionResult = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(txHash) {
        var _this$activeNearConne2, _this$activeWallet41;

        var connection, accountId, decodeHash, txResult;
        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                connection = (_this$activeNearConne2 = this.activeNearConnection) === null || _this$activeNearConne2 === void 0 ? void 0 : _this$activeNearConne2.connection;

                if (connection) {
                  _context33.next = 3;
                  break;
                }

                throw new Error('Near connection is undefined.');

              case 3:
                accountId = (_this$activeWallet41 = this.activeWallet) === null || _this$activeWallet41 === void 0 ? void 0 : _this$activeWallet41.account().accountId;

                if (accountId) {
                  _context33.next = 6;
                  break;
                }

                throw new Error('Account Id is undefined.');

              case 6:
                decodeHash = _nearApiJs.utils.serialize.base_decode(txHash);
                _context33.next = 9;
                return connection.provider.txStatus(decodeHash, accountId);

              case 9:
                txResult = _context33.sent;
                return _context33.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: txResult
                }));

              case 11:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, this);
      }));

      function fetchTransactionResult(_x66) {
        return _fetchTransactionResult.apply(this, arguments);
      }

      return fetchTransactionResult;
    }()
  }, {
    key: "getNearConfig",
    value:
    /**
     * Get NEAR configuration object. Defaults to testnet.
     * @param networkName
     * @param contractAddress
     */
    function getNearConfig(networkName, contractAddress) {
      var _this$constants, _this$constants2, _this$constants3;

      switch (networkName) {
        case _types.Network.testnet:
          return {
            networkId: 'testnet',
            nodeUrl: 'https://rpc.testnet.near.org',
            contractName: contractAddress || ((_this$constants = this.constants) === null || _this$constants === void 0 ? void 0 : _this$constants.FACTORY_CONTRACT_NAME) || _constants.FACTORY_CONTRACT_NAME,
            walletUrl: 'https://wallet.testnet.near.org',
            helperUrl: 'https://helper.testnet.near.org'
          };

        case _types.Network.mainnet:
          return {
            networkId: 'mainnet',
            nodeUrl: 'https://rpc.mainnet.near.org',
            contractName: contractAddress || ((_this$constants2 = this.constants) === null || _this$constants2 === void 0 ? void 0 : _this$constants2.FACTORY_CONTRACT_NAME) || _constants.FACTORY_CONTRACT_NAME,
            walletUrl: 'https://wallet.near.org',
            helperUrl: 'https://helper.mainnet.near.org'
          };

        default:
          return {
            networkId: 'testnet',
            nodeUrl: 'https://rpc.testnet.near.org',
            contractName: contractAddress || ((_this$constants3 = this.constants) === null || _this$constants3 === void 0 ? void 0 : _this$constants3.FACTORY_CONTRACT_NAME) || _constants.FACTORY_CONTRACT_NAME,
            walletUrl: 'https://wallet.testnet.near.org',
            helperUrl: 'https://helper.testnet.near.org'
          };
      }
    }
  }]);

  return Wallet;
}();

exports.Wallet = Wallet;